import { CommandType } from "~app/common/services/cqs/CommandType";
import { ProduktionsmallProduktBaseCommand } from "./ProduktionsmallProduktBaseCommand";

export class DeleteProduktionsmallProduktCommand extends ProduktionsmallProduktBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "DeleteProduktionsmallProduktCommand";

    constructor(produktionsmallGuid: string, handelssortimentId: number, produktId: number) {
        super(DeleteProduktionsmallProduktCommand.$type, CommandType.Delete);
        this.produktionsmallGuid = produktionsmallGuid;
        this.handelssortimentId = handelssortimentId;
        this.produktId = produktId;
    }
}
